import { Component, Inject, OnInit } from "@angular/core";
import { AppBarTitleService, SsoAccountFacade, UserMessageData, UserMessageBridgeService, UserMessageSubjects } from "common";
import { InsuranceService } from "../insurance.service";
import { ActivatedRoute, Router } from "@angular/router";
import { InsuranceQuoteBaseComponent } from "./insurance-quote-base.component";
import { EntityFacade } from "../../entity/domain/+state/entity.facade";

@Component({
    selector: "ifp-insurance-quote-message",
    templateUrl: "./insurance-quote.component.html",
    styleUrls: ["./insurance-quote.component.scss"],
    standalone: false
})
export class InsuranceQuoteMessageComponent
  extends InsuranceQuoteBaseComponent<UserMessageData>
  implements OnInit
{
  constructor(
    appBarTitleService: AppBarTitleService,
    insuranceService: InsuranceService,
    entityFacade: EntityFacade,
    router: Router,
    @Inject(UserMessageBridgeService) userMessageBridgeService: UserMessageBridgeService,
    route: ActivatedRoute,
    ssoAccountFacade: SsoAccountFacade
  ) {
    super(
      appBarTitleService,
      insuranceService,
      entityFacade,
      router,
      userMessageBridgeService,
      route,
      ssoAccountFacade
    );
    this.searchCondition = {
      subject: UserMessageSubjects.GeneralLiabilityInsurance,
    };
  }
}
